import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';

const inputClass =
  "block w-full rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none transition";

export default function SalesRepForm({ salesRep, submitPath, method = 'post', submitLabel }) {
  const [name, setName] = useState(salesRep.name || '');
  const [email, setEmail] = useState(salesRep.email || '');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const payload = { sales_rep: { name: name.trim(), email: email.trim() } };
    const opts = { onFinish: () => setSubmitting(false) };
    if (method === 'patch') router.patch(submitPath, payload, opts);
    else router.post(submitPath, payload, opts);
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm space-y-5">
      <div>
        <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-1.5">Name</label>
        <input id="name" className={inputClass} value={name} onChange={(e) => setName(e.target.value)}
               required autoFocus placeholder="Sam Rivera" />
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1.5">Email</label>
        <input id="email" type="email" className={inputClass} value={email}
               onChange={(e) => setEmail(e.target.value)} required placeholder="sam@123ceu.com" />
        <p className="mt-1 text-xs text-gray-500">
          Login links are emailed here. The rep signs in with a link, never a password.
        </p>
      </div>

      <div className="flex items-center gap-3 pt-1">
        <button type="submit" disabled={submitting}
                className="inline-flex items-center justify-center rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700 transition cursor-pointer disabled:opacity-50">
          {submitting ? 'Saving…' : submitLabel}
        </button>
        <Link href="/superadmin/sales_reps" className="text-sm font-semibold text-gray-600 hover:text-gray-900">
          Cancel
        </Link>
      </div>
    </form>
  );
}
